// extracted by mini-css-extract-plugin
module.exports = {"notice":"notice__2udbb","header":"header__3gt8J","body":"body__qQnx2"};